import {
  Row,
  Space,
  Table,
  Button,
  Form,
  notification,
  Col,
  Typography,
  Input,
  Select,
  DatePicker,
  message,
  Popover,
  AutoComplete,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "./ListExam.scss";
import {
  fields,
  fieldsSearch,
  listExamColumns,
  updatePhieuKhamNT,
} from "./ListExam.config";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  ListActionButton,
  ModalCustom,
  Notification,
} from "components/common";
import Icons from "assets/icons";
import { medicalExaminationService, catalogService, examOutService } from "api";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";

import dayjs from "dayjs";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tabKeys } from "types/enums";
import {
  CalendarSVG,
  CalendarSelectedSVG,
  ExcelSVG,
  ListIconSVG,
} from "assets";
import {
  setCurrentIdPKNT,
  setExaminationId,
  setIdPKNT,
  setIdReceiptExamOut,
} from "redux/reducer/examination";
import { setActiveKey, setIdPhieuKham } from "redux/reducer/common";
import { EXAM_BTN_CLICK_TYPE } from "types/enums/examination";
import { setEBCType } from "redux/reducer/examBtnClick";
import { parseDatetime, toDateTime } from "helper/format-date";
import {
  formatDateToString,
  getLocalValueUser,
  getTableOptions,
  saveLocalValueByUser,
  saveTableOptions,
} from "helper/common";
import ExamOutModal from "components/common/PrintReceipt/ExamOutModal/ExamOutModal";
import { listBacSy1 } from "data/list";
import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import KCBStatusColumn from "components/common/ColumnColors/KCBTypeColumn/KCBStatusColumn";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import CheckNullApi from "components/common/CheckNullApi/CheckNullApi";

const ListExam = () => {
  // redux
  let dispatch = useAppDispatch();
  let stateBtn = useAppSelector((state) => state.examClick.actionType);

  const [form] = Form.useForm();
  const [page, setPage] = useState<number>(1);
  const activeTab = useAppSelector((state) => state.common.activeTab);
  const [limit, setLimit] = useState<number>(50);
  const [data, setData] = useState<any>([]);
  const [dataDoctor, setDataDoctor] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [today, setToday] = useState<boolean>(true);
  const [yesterday, setYesterday] = useState<boolean>(false);
  const [selectedBtn, setSelectedBtn] = useState<number | null>(1);
  const idPK = useAppSelector((state) => state.common.idPhieuKham);
  const modalRef = useRef<any>();
  const expandRef = useRef<any>();
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 50,
    ngayTaoDen: dayjs(),
    ngayTaoTu: dayjs(),
  });
  const [currentPage, setCurrentPage] = useState<number>(1);

  const initialValues = {
    // phong: 0,
    ngayTaoTu: dayjs(),
    ngayTaoDen: dayjs(),
    trangThaiPK: 2,
    limit: limit,
  };
  let savedTableOption = getTableOptions(
    "EXAMINATION_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? listExamColumns.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : listExamColumns;

  const [columns, setColumns] = useState<any>(
    defaultColumns.filter((it) => it.show === true)
  );
  columns.map((e) => {
    if (e.key == "stt") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [searchValues, setSearchValues] = useState<any>({
    ...initialValues,
    ngayTaoTu: initialValues.ngayTaoTu.format("DD/MM/YYYY"),
    ngayTaoDen: initialValues.ngayTaoDen.format("DD/MM/YYYY"),
  });
  const fetchData = async () => {
    try {
      setLoading(true);
      let response: any = await medicalExaminationService.getListPKNT(
        formatParams()
      );
      setData(response?.data);
      setPage(response?.page);
      setLoading(false);
    } catch (error) {
      Notification("error", "Lỗi khi lấy danh sách bệnh nhân");
      setLoading(false);
    }
  };
  const onUpdate = async (record) => {
    if (record.trangThai === 1 || record.trangThai === 5) {
      let res = await updatePhieuKhamNT({
        id: record.id,
        trangThai: 2,
        bacSyKham: record.bacSyKham
          ? record.bacSyKham
          : localStorage.getItem("fullName"),
      });
      if (res) {
        dispatch(setExaminationId(record.idPhieuKham));
        dispatch(setIdPKNT(record.id));
        dispatch(setCurrentIdPKNT(record.id));
        dispatch(setActiveKey(tabKeys.EXAMINATION.INFOR_DETAIL));
      } else {
        notification.error({ message: "Lỗi khi chuyển trạng thái khám bệnh!" });
      }
    } else {
      dispatch(setExaminationId(record.idPhieuKham));
      dispatch(setIdPKNT(record.id));
      dispatch(setActiveKey(tabKeys.EXAMINATION.INFOR_DETAIL));
    }
  };

  const onPageChange = (pg: number, pageSize?: number) => {
    setCurrentPage(pg);
    setParams({ ...params, page: pg, limit: pageSize });
    setLimit(limit);
  };
  const currentIdPKNT = useAppSelector((e) => e.examination.currentIdPKNT);
  const idPKNT = useAppSelector((e) => e.examination.idPKNT);
  const onRowSelect = (selectedRowKeys, selectedRows, info) => {
    const record = selectedRows[0];
    dispatch(setExaminationId(record.idPhieuKham));
    dispatch(setIdPKNT(record.id));
    dispatch(setIdPhieuKham(record?.idPhieuKham));
    if (!currentIdPKNT) {
      dispatch(setCurrentIdPKNT(record.id));
    } else dispatch(setCurrentIdPKNT(idPKNT));
  };
  const setShowColumns = (showColumns) => {
    saveTableOptions(
      "EXAMINATION_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const formatParams = () => {
    return {
      ...params,
      ngaySinh: formatDateToString(params.ngaySinh),
      ngayTaoTu: formatDateToString(params.ngayTaoTu),
      ngayTaoDen: formatDateToString(params.ngayTaoDen),
    };
  };

  useEffect(() => {
    if (stateBtn === EXAM_BTN_CLICK_TYPE.RELOAD_LIST_EXAM) {
      fetchData();
      dispatch(setEBCType(EXAM_BTN_CLICK_TYPE.NONE));
    }
  }, [stateBtn]);

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      onClickSearchButton();
    }
  };

  const printFunc = async (record) => {
    dispatch(setIdReceiptExamOut(record.id));
    modalRef.current?.openModal();
  };
  const editFunc = async (record) => {
    if (record.trangThai === 1 || record.trangThai === 5) {
      let res = await updatePhieuKhamNT({
        id: record.id,
        trangThai: 2,
        bacSyKham: record.bacSyKham
          ? record.bacSyKham
          : localStorage.getItem("fullName"),
      });
      if (res) {
        dispatch(setExaminationId(record.idPhieuKham));
        dispatch(setIdPKNT(record.id));
        dispatch(setActiveKey(tabKeys.EXAMINATION.INFOR_DETAIL));
      } else {
        notification.error({
          message: "Lỗi khi chuyển trạng thái khám bệnh!",
        });
      }
    } else {
      dispatch(setExaminationId(record.idPhieuKham));
      dispatch(setIdPKNT(record.id));
      dispatch(setActiveKey(tabKeys.EXAMINATION.INFOR_DETAIL));
    }
  };
  columns.map((it) => {
    if (it.dataIndex === "action") {
      it.render = (v, record: any, idx) => {
        const delFunc = async (record) => {
          if (record?.trangThai == 3) {
            onUpdateStatus(7);
          } else {
            onUpdateStatus(6);
          }
        };
        const onUpdateStatus = async (status) => {
          let message = "";
          if (status == 3) {
            message = "hủy khám";
          } else {
            message = "xóa thông tin";
          }
          try {
            let response = await updatePhieuKhamNT({
              id: record.id,
              trangThai: status,
            });
            Notification("success", `Đã ${message}!`);

            dispatch(setEBCType(EXAM_BTN_CLICK_TYPE.RELOAD_LIST_EXAM));
          } catch (err) {
            Notification("error", `Lỗi khi ${message}!`);
          }
        };
        return (
          <ListActionButton
            deleteFunction={() => delFunc(record)}
            printFunction={() => printFunc(record)}
            editFunction={() => editFunc(record)}
          />
        );
      };
      // if (columns.find((e) => e.dataIndex == "STT")) {
      //   columns.find((e) => e.dataIndex == "STT").render = (
      //     text,
      //     record,
      //     index
      //   ) => {
      //     const rowNumber = (page - 1) * limit + index + 1;
      //     return rowNumber;
      //   };
      // }
    }
  });

  const getLisDoctor = async () => {
    try {
      const res = await examOutService.getLisDoctor();
      const opt = res.data.map((el) => ({
        value: `BS. ${el.hoTen}`,
        label: `BS. ${el.hoTen}`,
      }));

      setDataDoctor(opt);
    } catch (error) {
      let count: number;
      for (let index = 0; index <= count; index++) {
        getLisDoctor();
        count++;
      }
    }
  };
  useEffect(() => {
    console.log(dataDoctor);
    fieldsSearch.find((e) => e?.name == "bacSyKham").options = dataDoctor;
  }, [dataDoctor]);

  // getLisDoctor();
  const onClickSearchButton = () => {
    const searchFields = expandRef.current?.getData();
    setCurrentPage(1);
    setParams({
      ...params,
      ...searchFields,
      trangThaiKBNT: searchFields.trangThaiKBNT
        ? JSON.stringify(searchFields.trangThaiKBNT)
            .replace("[", "")
            .replace("]", "")
        : null,
      page: 1,
    });
  };
  //check xem có đủ api chưa?
  useEffect(() => {
    if (activeTab === tabKeys.EXAMINATION.LIST_EXAM) {
      fetchData();
    }
  }, [params, activeTab]);
  useEffect(() => {
    getLisDoctor();
    CheckNullApi();
  }, []);
  const onToday = (key: number) => {
    setLoading(true);
    let today = dayjs();
    expandRef.current?.setFieldValue("ngayTaoTu", today);
    expandRef.current?.setFieldValue("ngayTaoDen", today);
    setParams({ ...params, ...expandRef.current?.getData() });
    setSelectedBtn(key);
  };
  const onYesterday = (key: number) => {
    setLoading(true);
    let yesterday = dayjs().subtract(1, "day");
    expandRef.current?.setFieldValue("ngayTaoTu", yesterday);
    expandRef.current?.setFieldValue("ngayTaoDen", yesterday);
    setParams({
      ...params,
      ...expandRef.current?.getData(),
    });

    setSelectedBtn(key);
  };
  const label = [
    {
      key: 1,
      value: "Hôm nay",
      onclick: (e) => onToday(e),
    },
    {
      key: 2,
      value: "Hôm qua",
      onclick: (e) => onYesterday(e),
    },
  ];
  return (
    <div className="list-exam-container" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="container">
        <Space direction="vertical" style={{ width: "100%" }}>
          <ExpandSearch
            ref={expandRef}
            onClickSearch={onClickSearchButton}
            fields={fieldsSearch}
            onReset={onClickSearchButton}
            initialValues={params}
            isSearchExpend={false}
          />
        </Space>
      </div>
      <div className="container">
        <Row gutter={[0, 8]}>
          <Row justify={"end"} gutter={[16, 16]}>
            <Space>
              {label.map((item) => (
                <Button
                  key={item.key}
                  onClick={() => {
                    item.onclick(item.key);
                  }}
                  className={
                    item.key === selectedBtn ? "btn-sub" : "custom-btn"
                  }
                  icon={
                    item.key === selectedBtn ? (
                      <CalendarSelectedSVG />
                    ) : (
                      <CalendarSVG />
                    )
                  }
                >
                  {item.value}
                </Button>
              ))}
              <Popover
                trigger="click"
                placement="topLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowColumns}
                    columns={defaultColumns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button className="btn-sub" icon={<ListIconSVG />}>
                  Cột hiển thị
                </Button>
              </Popover>
            </Space>
          </Row>
          <CustomResizableTable
            rowKey={(record) => record.id}
            // setShowColumns={setShowColumns}
            // className="custom-resize-table-scroll"
            // scroll={{x: '100%', y: 500}}
            tableLayout="auto"
            columns={columns}
            dataSource={data.data}
            loading={loading}
            bordered
            setShowColumns={setShowColumns}
            onRow={(record, rowIndex) => {
              return {
                onDoubleClick: (e) => onUpdate(record),
              };
            }}
            rowSelection={{
              type: "radio",
              onChange: onRowSelect,
            }}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              onChange: onPageChange,
              total: data.total,
              current: currentPage,
              pageSize: params.limit,
            }}
          />
          <ModalCustom
            wrapClassName="modal-print-form"
            ref={modalRef}
            width={1000}
            centered
          >
            <ExamOutModal></ExamOutModal>
          </ModalCustom>
        </Row>
      </div>
    </div>
  );
};

export default ListExam;
